import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { PageHeader } from '../main/LayoutStyles';
import apiClient from '../services/api';
import InviteForm from './InviteForm';
import MemberList from './MemberList';
import styled from 'styled-components';
import { Loader2 } from 'lucide-react';

const Tabs = styled.div`
    display: flex;
    border-bottom: 2px solid #e2e8f0;
    margin-top: 2rem;
`;
const Tab = styled.button`
    padding: 1rem 1.5rem;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: 600;
    color: ${({ theme, active }) => active ? theme.colors.primary : theme.colors.textMedium};
    border-bottom: 2px solid ${({ theme, active }) => active ? theme.colors.primary : 'transparent'};
    margin-bottom: -2px;
`;

const TabContent = styled.div`
    padding: 2rem 0;
`;

const OrganizationDetail = () => {
    const { orgId } = useParams();
    const [organization, setOrganization] = useState(null);
    const [activeTab, setActiveTab] = useState('members');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (orgId) {
            setLoading(true);
            apiClient.get(`/organizations/${orgId}`)
                .then(res => setOrganization(res.data))
                .catch(err => console.error("Błąd ładowania szczegółów organizacji:", err))
                .finally(() => setLoading(false));
        }
    }, [orgId, refreshTrigger]);

    const handleStaffInvited = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    if (loading) {
        return <div style={{textAlign: 'center', padding: '2rem'}}><Loader2 className="icon-spin" /></div>;
    }

    if (!organization) return <div>Nie udało się załadować danych organizacji.</div>;

    const managerRole = { "ROLE_ADMIN": "Menedżer Organizacji" };

    return (
        <div>
            <Link to="/app/system-admin-panel/organizations" style={{fontWeight: 600}}>&larr; Wróć do listy organizacji</Link>
            <PageHeader>{organization.name}</PageHeader>

            <Tabs>
                <Tab active={activeTab === 'members'} onClick={() => setActiveTab('members')}>Członkowie i Zaproszenia</Tab>
                {/* Zakładka 'Kody dla uczniów' została usunięta z tego widoku */}
            </Tabs>

            <TabContent>
                {activeTab === 'members' && (
                    <>
                        <InviteForm
                            organizationId={orgId}
                            availableRoles={managerRole}
                            endpoint={`/system-admin/organizations/${orgId}/invite-manager`}
                            onStaffInvited={handleStaffInvited}
                            title="Zaproś Nowego Menedżera do Organizacji"
                            description="Osoba zaproszona otrzyma uprawnienia do zarządzania tą organizacją, jej personelem i grupami."
                        />
                        <MemberList organizationId={orgId} keyForRefresh={refreshTrigger} />
                    </>
                )}
            </TabContent>
        </div>
    );
};

export default OrganizationDetail;